import {
  Card,
  CardActionArea,
  CardContent,
  Paper,
  Typography,
  useMediaQuery,
  Modal,
  Button,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useEffect } from "react";

import Event1 from "../../../images/event1.jpg";
import Doc1 from "../../../upload/test.pdf";
import Grid from "@mui/material/Grid2";
import "./dashboard.css";

import Carousel from "react-bootstrap/Carousel";
import { useNavigate } from "react-router-dom";
import PinDropIcon from "@mui/icons-material/PinDrop";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { IoMdHome } from "react-icons/io";
import { useState } from "react";
import getEventController from "../Controller/getEvent_controller.js";
import PPKMLogo from "../../../images/ppkmLogo.jpg";

const Dashboard = () => {
  const [spacing, setSpacing] = React.useState(2);
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const memberId = localStorage.getItem("memberId");

  // console.log(memberId);

  // State for managing modal
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [open, setOpen] = useState(false);

  const [events, setEvents] = useState([]); // Dynamic events array

  useEffect(() => {
    // Fetch events data on component mount
    getEventController.getUpcomingEventRows().then((response) => {
      if (Array.isArray(response)) {
        // Map the data into the format expected for each event
        const dynamicEvents = response.map((item) => {
          const startDate = new Date(item.event_start_datetime);
          const endDate = new Date(item.event_end_datetime);

          // Format the dates as "DD-MMM-YYYY" (e.g., "12-Jan-2024")
          const dateFormatter = new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });

          return {
            id: item.eventID,
            imgSrc: item.event_poster,
            title: item.event_name || "Untitled Event",
            startdate: item.event_start_datetime
              ? dateFormatter.format(startDate)
              : "Date not available",
            enddate: item.event_end_datetime
              ? dateFormatter.format(endDate)
              : "Date not available",
            venue: item.event_venue || "Venue not specified",
          };
        });

        setEvents(dynamicEvents); // Update the state with formatted events
      }
    });
  }, []);

  const baseUrl = "https://ppkm.org.my/mobile_backend/assets/highlights/";
  const imageFiles = [
    "m1.jpg",
    "m2.jpg",
    "m3.jpg",
    "m4.jpg",
    "m5.jpg",
    "m6.jpg",
    "m7.jpg",
    "m8.jpg",
    "m9.jpg",
    "m10.jpg",
    "m11.jpg",
    "m12.jpg",
    "m13.jpg",
    "m14.jpg",
    "m15.jpg",
    "m16.jpg",
    "m17.jpg",
    "m18.jpg",
    "m19.jpg",
    "m20.jpg",
    "m21.jpg",
    "m22.jpg",
    "m23.jpg",
    "m24.jpg",
    "m25.jpg",
    "m26.jpg",
    "m27.jpg",
    "m28.jpg",
    "m29.jpg",
    "m30.jpg",
    "m31.jpg",
    "m32.jpg",
    "m33.jpg",
    "m34.jpg",
    "m35.jpg",
    "m36.jpg",
    "m37.jpg",
    "m38.jpg",
    "m39.jpg",
    "m40.jpg",
    "m41.jpg",
    "m42.jpg",
    "m43.jpg",
    "m44.jpg",
    "m45.jpg",
    "m46.jpg",
    "m47.jpg",
    "m48.jpg",
    "m49.jpg",
    "m50.jpg",
    "m51.jpg",
    "m52.jpg",
    "m53.jpg",
    "m54.jpg",
    "m55.jpg",
    "m56.jpg",
  ]; // Add all image file names here

  // Sample events array with image and title data
  const documents = [
    {
      imgSrc: Event1,
      title: "SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION SEMINARS (SMMCES)",
      pdf: Doc1,
    },
    { imgSrc: Event1, title: "ANOTHER EVENT TITLE" },
  ];

  // Handle click to open modal and set the selected document
  const handleOpen = (doc) => {
    setSelectedDocument(doc);
    setOpen(true);
  };

  // Handle close modal
  const handleClose = () => {
    setOpen(false);
    setSelectedDocument(null);
  };

  // Handle download function
  const handleDownload = () => {
    if (selectedDocument) {
      const link = document.createElement("a");
      link.href = selectedDocument.imgSrc;
      link.download = selectedDocument.title; // sets download filename
      link.click();
    }
  };

  const handleEventClick = (eventId) => {
    navigate(`/event_details/${eventId}`);
  };

  useEffect(() => {
    console.log(window.location.href); // Logs the current URL
  }, []);
  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="dashboard-wrapper">
          <div className="dashboard">
            {/*my event row */}
            <div className="card-row">
              <Card sx={{ minWidth: 275, margin: 0 }} className="outer-card">
                <CardContent>
                  <Typography sx={{ fontSize: 20 }} color="white">
                    My Next Events
                  </Typography>
                  <CardActionArea onClick={() => navigate("/view_event")}>
                    <Card
                      sx={{ minWidth: 275, margin: 0 }}
                      className="inner-card"
                    >
                      <div className="card-content">
                        <img src={Event1} className="icon" />
                        <div className="text-content">
                          <Typography sx={{ fontSize: 12, mt: 1.5 }}>
                            SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION
                            SEMINARS (SMMCES)
                          </Typography>
                          <Typography sx={{ fontSize: 10, mt: 1.5 }}>
                            <CalendarMonthIcon className="dashboard-icon" />
                            9-11 August 2024
                          </Typography>
                          <Typography sx={{ fontSize: 10 }}>
                            <PinDropIcon className="dashboard-icon" />
                            JW Marriott Kuala Lumpur
                          </Typography>
                        </div>
                      </div>
                    </Card>
                  </CardActionArea>
                </CardContent>
              </Card>
            </div>
            {/*highlight row */}
            <div className="highlight-row">
              <div className="highlights-panel">
                <Carousel>
                  <Carousel.Item>
                    <img src={Event1} text="First slide" />
                  </Carousel.Item>
                  <Carousel.Item>
                    <img src={Event1} text="second slide" />
                  </Carousel.Item>
                  <Carousel.Item>
                    <img src={Event1} text="third slide" />
                  </Carousel.Item>
                </Carousel>
              </div>
            </div>
            {/*upcoming event section */}
            <div className="upcoming-event-row">
              <div>
                <Typography
                  sx={{ fontSize: 25, fontWeight: "bold" }}
                  className="upcoming-event-label"
                >
                  Upcoming Events to Join
                  <NavigateNextIcon
                    className="upcoming-event-label-icon"
                    onClick={() => navigate("/discover_event")}
                  />
                </Typography>
              </div>
              <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                {events.slice(0, 2).map((event, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={index}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Paper
                      sx={(theme) => ({
                        display: "flex",
                        height: 180,
                        width: 160,
                        marginTop: "20px",
                        backgroundColor: "#fff",
                        ...theme.applyStyles("dark", {
                          backgroundColor: "#1A2027",
                        }),
                        boxShadow: 5,
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "15px",
                        cursor: "pointer",
                        transition: "transform 0.3s ease-in-out", // Smooth zoom effect
                        "&:hover": {
                          transform: "scale(1.05)", // Slight zoom on hover
                          boxShadow: 10, // Optionally increase shadow on hover
                        },
                      })}
                      onClick={() => handleEventClick(event.id)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontSize: "12px",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        <img
                          src={event.imgSrc}
                          alt={event.title}
                          className="upcoming-event-icon"
                        />
                        {/* <span>{event.title}</span> */}
                      </div>
                    </Paper>
                  </Grid>
                ))}
                {/* "More Details" button as the last Grid item */}
                {/* <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Paper
                    onClick={() => navigate("/discover_event")}
                    sx={(theme) => ({
                      display: "flex",
                      height: 300,
                      width: 250,
                      marginTop: "20px",
                      backgroundColor: "#fff",
                      ...theme.applyStyles("dark", {
                        backgroundColor: "#1A2027",
                      }),
                      boxShadow: 5,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    })}
                  >
                    <Typography
                      sx={{ fontSize: 18, fontWeight: "bold", color: "black" }}
                    >
                      Discover More
                      <NavigateNextIcon className="discover-more-icon" />
                    </Typography>
                  </Paper>
                </Grid> */}
              </Grid>
            </div>
            {/*document section */}
            <div className="document-row">
              <div>
                <Typography
                  sx={{ fontSize: 25, fontWeight: "bold" }}
                  className="upcoming-event-label"
                >
                  Documents
                  <NavigateNextIcon
                    className="upcoming-event-label-icon"
                    onClick={() => navigate("/document")}
                  />
                </Typography>
              </div>
              <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                {documents.slice(0, 2).map((doc, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={index}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Paper
                      sx={(theme) => ({
                        display: "flex",
                        height: 180,
                        width: 160,
                        marginTop: "20px",
                        backgroundColor: "#fff",
                        ...theme.applyStyles("dark", {
                          backgroundColor: "#1A2027",
                        }),
                        boxShadow: 5,
                        justifyContent: "center",
                        alignItems: "center",
                      })}
                      onClick={() => handleOpen(doc)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontSize: "12px",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        <img
                          src={doc.imgSrc}
                          alt={doc.title}
                          className="upcoming-event-icon"
                        />
                        {/* <span>{doc.title}</span> */}
                      </div>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
        </div>
      ) : (
        <div className="dashboard-wrapper">
          <div className="dashboard">
            {/* <span className="dashboard-title">
              Dashboard
            </span> */}
            {/*highlight row */}
            <div className="highlight-row">
              <div className="highlights-panel">
                <Carousel>
                  {imageFiles.map((fileName, index) => (
                    <Carousel.Item key={index}>
                      <img
                        src={`${baseUrl}${fileName}`}
                        alt={`Slide ${index + 1}`}
                        className="d-block w-100"
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </div>
            {/*my event row */}
            {/* <div className="card-row">
              <Card sx={{ margin: 0, boxShadow: 5 }} className="outer-card2">
                <CardContent>
                  <Typography
                    sx={{ fontSize: 25, fontWeight: "bold" }}
                    color="black"
                  >
                    My Next Events
                  </Typography>
                  <CardActionArea onClick={() => navigate("/view_event")}>
                    <Card
                      sx={{ minWidth: 275, margin: 0, height: 140 }}
                      className="inner-card"
                    >
                      <div className="card-content">
                        <img src={Event1} className="large-icon" />
                        <div className="text-content">
                          <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>
                            SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION
                            SEMINARS (SMMCES)
                          </Typography>
                          <Typography
                            sx={{ fontSize: 12, fontWeight: "bold", mt: 1.5 }}
                          >
                            <CalendarMonthIcon className="dashboard-icon" />
                            9-11 August 2024
                          </Typography>
                          <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>
                            <PinDropIcon className="dashboard-icon" />
                            JW Marriott Kuala Lumpur
                          </Typography>
                        </div>
                      </div>
                    </Card>
                  </CardActionArea>
                </CardContent>
              </Card>
              <Card sx={{ margin: 0, boxShadow: 5 }} className="outer-card2">
                <CardContent>
                  <Typography
                    sx={{ fontSize: 25, fontWeight: "bold" }}
                    color="black"
                  >
                    My Membership
                  </Typography>
                  <CardActionArea
                    onClick={() => navigate("/membership_renewal")}
                  >
                    <Card
                      sx={{ minWidth: 275, margin: 0, height: 140 }}
                      className="inner-card"
                    >
                      <div className="card-content">
                        <div className="text-content">
                          <Typography sx={{ fontSize: 21, fontWeight: 900 }}>
                            Appointed Affiliate Member
                          </Typography>
                          <Typography
                            sx={{ fontSize: 12, fontWeight: "bold", mt: 1.5 }}
                          >
                            Company Name: Neudimenxion
                          </Typography>
                          <Typography
                            sx={{ fontSize: 12, fontWeight: "bold", mt: 1 }}
                          >
                            Membership Status: ACTIVE
                          </Typography>
                          <Typography
                            sx={{ fontSize: 12, fontWeight: "bold", mt: 1 }}
                          >
                            Membership Validity: 1 Jan 2024 - 31 Dec 2024
                          </Typography>
                        </div>
                      </div>
                    </Card>
                  </CardActionArea>
                </CardContent>
              </Card>
            </div> */}

            {/*upcoming event section */}
            <div className="upcoming-event-row">
              <Typography sx={{ fontSize: 25, fontWeight: "bold" }}>
                Upcoming Events to Join
              </Typography>
              {events.length === 0 ? (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <p>No Upcoming Events</p>
                </div>
              ) : (
                <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                  {events.slice(0, 4).map((event, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      key={index}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Paper
                        sx={(theme) => ({
                          display: "flex",
                          height: 300,
                          width: 250,
                          marginTop: "20px",
                          backgroundColor: "#fff",
                          ...theme.applyStyles("dark", {
                            backgroundColor: "#1A2027",
                          }),
                          boxShadow: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "15px",
                          cursor: "pointer",
                          transition: "transform 0.3s ease-in-out", // Smooth zoom effect
                          "&:hover": {
                            transform: "scale(1.05)", // Slight zoom on hover
                            boxShadow: 10, // Optionally increase shadow on hover
                          },
                        })}
                        onClick={() => handleEventClick(event.id)}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            fontSize: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            padding: "15px",
                          }}
                        >
                          {/* <img
                            src={event.imgSrc}
                            alt={event.title}
                            className="upcoming-event-icon"
                          /> */}
                          <img
                            src={
                              event.imgSrc && event.imgSrc.trim() !== ""
                                ? event.imgSrc
                                : PPKMLogo
                            }
                            alt={event.title}
                            className="upcoming-event-icon"
                          />
                          <span>{event.title}</span>
                        </div>
                      </Paper>
                    </Grid>
                  ))}
                  {/* "More Details" button as the last Grid item */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Paper
                      onClick={() => navigate("/discover_event")}
                      sx={(theme) => ({
                        display: "flex",
                        height: 300,
                        width: 250,
                        marginTop: "20px",
                        backgroundColor: "#fff",
                        ...theme.applyStyles("dark", {
                          backgroundColor: "#1A2027",
                        }),
                        boxShadow: 5,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        borderRadius: "15px",
                        cursor: "pointer",
                        transition: "transform 0.3s ease-in-out", // Smooth zoom effect
                        "&:hover": {
                          transform: "scale(1.05)", // Slight zoom on hover
                          boxShadow: 10, // Optionally increase shadow on hover
                        },
                      })}
                    >
                      <Typography
                        sx={{
                          fontSize: 18,
                          fontWeight: "bold",
                          color: "black",
                        }}
                      >
                        Discover More
                        <NavigateNextIcon className="discover-more-icon" />
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              )}
            </div>

            {/*document section */}
            {/* <div className="document-row">
              <Typography sx={{ fontSize: 25, fontWeight: "bold" }}>
                Documents
              </Typography>
              <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                {documents.map((doc, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={index}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Paper
                      sx={(theme) => ({
                        display: "flex",
                        height: 300,
                        width: 250,
                        marginTop: "20px",
                        backgroundColor: "#fff",
                        ...theme.applyStyles("dark", {
                          backgroundColor: "#1A2027",
                        }),
                        boxShadow: 5,
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "15px",
                        cursor: "pointer",
                        transition: "transform 0.3s ease-in-out", // Smooth zoom effect
                        "&:hover": {
                          transform: "scale(1.05)", // Slight zoom on hover
                          boxShadow: 10, // Optionally increase shadow on hover
                        },
                      })}
                      onClick={() => handleOpen(doc.pdf)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontSize: "12px",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        <img
                          src={doc.imgSrc}
                          alt={doc.title}
                          className="upcoming-event-icon"
                        />
                        <span>{doc.title}</span>
                      </div>
                    </Paper>
                  </Grid>
                ))}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Paper
                    onClick={() => navigate("/document")}
                    sx={(theme) => ({
                      display: "flex",
                      height: 300,
                      width: 250,
                      marginTop: "20px",
                      backgroundColor: "#fff",
                      ...theme.applyStyles("dark", {
                        backgroundColor: "#1A2027",
                      }),
                      boxShadow: 5,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    })}
                  >
                    <Typography
                      sx={{ fontSize: 18, fontWeight: "bold", color: "black" }}
                    >
                      Discover More
                      <NavigateNextIcon className="discover-more-icon" />
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </div> */}
          </div>
        </div>
      )}

      {/* Modal for Preview */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {selectedDocument && (
            <>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {selectedDocument.title}
              </Typography>
              <img
                src={selectedDocument.imgSrc}
                alt={selectedDocument.title}
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleDownload}
                sx={{ mt: 2 }}
              >
                Download
              </Button>
            </>
          )}
        </Box>
      </Modal>

      {/* Dialog to show the PDF preview */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogContent>
          {selectedDocument ? (
            <iframe
              src={selectedDocument}
              title="PDF Preview"
              width="100%"
              height="600px"
              style={{ border: "none" }}
            ></iframe>
          ) : (
            <p>Loading...</p>
          )}
        </DialogContent>
        <DialogActions>
          {/* Download Button */}
          <Button
            component="a"
            href={selectedDocument}
            download
            target="_blank"
            rel="noopener noreferrer"
            // color="primary"
            variant="contained"
            sx={{
              background: "#d33333",
            }}
          >
            Download
          </Button>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Dashboard;
